import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { ref, reactive, toRefs } from "vue";
import apis from "@/api";
import { Plus } from '@element-plus/icons-vue';
export default {
  name: "UploadCopyright",
  components: {
    Plus
  },
  props: {
    uploading: {
      type: Number,
      default: 0
    },
    copyrightId: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const data = reactive({
      fileList: [],
      copyrightForm: {},
      rules: {
        authorizedFiles: [{
          validator: validateFiles,
          trigger: "blur"
        }],
        authorizedTime: [{
          required: true,
          message: "请输入授权时间",
          trigger: "blur"
        }],
        useRequire: [{
          required: true,
          message: "请输入使用平台要求",
          trigger: "blur"
        }]
      }
    });
    function validateFiles(rule, value, callback) {
      if (data.fileList.length <= 0) {
        callback(new Error("请选择授权文件"));
      } else {
        callback();
      }
    }
    const upload = ref(null);
    const formRef = ref(null);
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };
    const submit = async () => {
      await upload.value.submit();
      await formRef.value.validate().then(async valid => {
        if (valid) {
          await submitUpload();
        } else {
          context.emit('update:uploading', -1);
        }
      }).catch(() => {
        context.emit('update:uploading', -1);
      });
    };
    const submitUpload = async () => {
      const formData = new FormData();
      for (const f of data.fileList) {
        formData.append('fileList', f);
      }
      formData.append('bucketName', 'outer-for-inner');
      await apis.upload(formData).then(async res => {
        if (res.success && res.data && res.data.length > 0) {
          let urls = [];
          for (const f of res.data) {
            urls.push(f.relativeUrl);
          }
          data.copyrightForm.authorizedFiles = urls.join(',');
          await submitCopyRight();
        } else {
          ElMessage.error('授权文件上传失败');
          context.emit('update:uploading', -1);
        }
      }).catch(() => {
        ElMessage.error('授权文件上传失败');
        context.emit('update:uploading', -1);
      });
    };
    const submitCopyRight = async () => {
      await apis.addCopyright(data.copyrightForm).then(res => {
        if (res.success) {
          data.fileList = [];
          data.copyrightForm = {};
          context.emit('update:copyrightId', res.data);
          context.emit('update:uploading', 1);
        } else {
          ElMessage.error('授权信息保存失败');
          context.emit('update:uploading', -1);
        }
      }).catch(() => {
        ElMessage.error('授权信息保存失败');
        context.emit('update:uploading', -1);
      });
    };
    const fileUpload = params => {
      data.fileList.push(params.file);
      let fileNames = [];
      let files = [];
      a: for (const f of data.fileList) {
        let n = f.name;
        b: for (const name of fileNames) {
          if (name == f.name) {
            continue a;
          }
        }
        fileNames.push(n);
        files.push(f);
      }
      data.fileList = files;
    };
    return {
      ...toRefs(data),
      upload,
      formRef,
      handleRemove,
      submit,
      fileUpload
    };
  }
};